module.exports = __webpack_public_path__ + "static/media/finish@2x.ab241ad9.png";